import Domain from '../../../../domain/models/Domain';

/** Options of the domain select: one archived state, plus the selected domains whatever their state. */
const domainSelectOptions = (
  domains: Pick<Domain, 'id' | 'name' | 'archived'>[],
  archived: boolean,
  selected: string[]
): { label: string; value: string }[] =>
  domains
    .filter((domain) => domain.archived === archived || selected.includes(domain.id))
    .map((domain) => ({ label: domain.name, value: domain.id }));

export default domainSelectOptions;